import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Media from 'components/common/Media'
import Text from 'components/common/Text/Text'
import PrintButton from 'components/common/PrintButton/PrintButton'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import PhoneLink from 'components/common/PhoneLink'
import { composePhoneNumberFromObject, composeFormattedPhoneNumberFromObject } from 'helpers/phone-number'
import {
  SCHEDULE_SENT_BLOCK_DESCRIPTION,
  REQUEST_SENT_BLOCK_DESCRIPTION,
  SENT_APPOINTMENT_TITLE,
  SENT_SCHEDULE_TITLE,
  REACH_OUT_E2E_TITLE,
  REACH_OUT_REQUEST_TITLE
} from 'constant'
import DurationInfo from '../DurationInfo'

const RequestSentBlock = ({ fields, storePhoneNumber, isE2EAppointment }) =>
  <Container>
    <Media.Desktop>
      <PrintButtonWrapper>
        <PrintButton title="Print" />
      </PrintButtonWrapper>
    </Media.Desktop>
    <Title>
      { isE2EAppointment ? SENT_SCHEDULE_TITLE : SENT_APPOINTMENT_TITLE }
    </Title>
    <MainContentWrapper>
      <Subtitle>
        { isE2EAppointment ? SCHEDULE_SENT_BLOCK_DESCRIPTION : REQUEST_SENT_BLOCK_DESCRIPTION }
      </Subtitle>
      {fields.map(({ name, value, id }) => value
        ? (
          <Row className="appointment-field-row " key={ name }>
            <FieldName className="field-label">{ name }</FieldName>
            <FieldContent className="field-value" breakAnywhere={ name === 'Email:' } id={ id }>
              { value }
            </FieldContent>
          </Row>
        ) : null)}
      <CallContainer>
        Please call the store at{' '}
        <PhoneNumberWrapper>
          <Media.Desktop>
            <CallText>{ composeFormattedPhoneNumberFromObject(storePhoneNumber) }</CallText>
          </Media.Desktop>
          <Media.Mobile>
            <PhoneLink number={ composePhoneNumberFromObject(storePhoneNumber) } />
          </Media.Mobile>
        </PhoneNumberWrapper>{' '}
        { isE2EAppointment ? REACH_OUT_E2E_TITLE : REACH_OUT_REQUEST_TITLE }
      </CallContainer>
      <DurationInfo />
    </MainContentWrapper>
  </Container>

export default RequestSentBlock

RequestSentBlock.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string
    })
  ),
  isE2EAppointment: PropTypes.bool,
  storePhoneNumber: PropTypes.shape()
}

const Container = styled.div`
  ${Media.desktop`
    box-shadow: 0 0 10px rgba(113, 113, 113, 0.349);
  `}
  ${Mixin.responsive('margin-top', '90px', '20px')}
  ${Mixin.responsive('padding', '30px 60px 100px', '20px')}
`

const MainContentWrapper = styled.div`
  margin: 0 auto;
  ${Mixin.responsive('width', '60%', '100%')}
`

const Title = styled.div`
  ${Mixin.font.GothamBold(26, 600)}
  margin: 30px 0 10px;
  text-align: center;
  text-transform: uppercase;
`

const Subtitle = styled(Text)`
  display: block;
  margin: 25px 0 40px 0;
  ${Media.mobile`
    text-align: center;
  `}
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px 0;
  border-bottom: 1px solid ${Theme.colors.light_grey};
  padding-bottom: 10px;
`

const FieldName = styled.div`
  flex: 1;
  text-align: left;
  line-height: 20px;
`

const FieldContent = styled.div`
  flex: 2;
  font-weight: 650;
  text-align: left;
  line-height: 20px;
  ${props => props.breakAnywhere && css`
    overflow-wrap: anywhere;
  `}
`

const PrintButtonWrapper = styled.div`
  text-align: right;
`

const PhoneNumberWrapper = styled.div`
  display: inline-block;
`

const CallText = styled(Text)`
  font-weight: 650;
`

const CallContainer = styled.div`
  margin-top: 40px;
  ${Media.mobile`
    text-align: center;
  `}
`
